var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"segment-list"},[_c('v-list',[_vm._l((_vm.segments),function(segment,index){return [_c('Segment-effort-list-item',_vm._g({key:index,attrs:{"item":segment}},_vm.$listeners))]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }